export { CruiseDetailsVariant } from './CruiseDetailsPanel.types';
